// dependency: selectize
(function() {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('sodSelector', directiveFunc);

    function directiveFunc() {
        return {
            restrict: 'E',
            scope: {
                element: '=',
                onSelect: '&',
                refresh: '=?'
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: directiveCtrl,
            template: '<selectize config="vm.config" options="vm.ds" ng-model="vm.selected"></selectize>'
        };

        function directiveCtrl(FbSelectService, lodash, GenericModel, $scope) {
            const vm = this;
            this.$onInit = function() {
                vm.selected = null;
                vm.refresh = loadRemoteData;

                vm.additionalOptions = {};

                FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

                if (lodash.has(vm.element, 'datasource.data')) {
                    vm.ds = angular.copy(lodash.get(vm.element, 'datasource.data', null));
                    $scope.$watch(function() {return vm.element.datasource.data; }, function() { vm.ds = angular.copy(lodash.get(vm.element, 'datasource.data', null)); });
                } else {
                    loadRemoteData();
                }

                vm.config =
                    angular.merge(
                        {
                            highlight: true,
                            create: false,
                            labelField: 'label',
                            valueField: 'value',
                            maxItems: 1,
                            searchField: ['label'],
                            plugins: ['remove_button'],
                            onChange: function(selectedValue) {
                                const selected = lodash.find(vm.ds, function(item) {
                                    return lodash.get(item, lodash.get(vm.config, 'valueField', 'value'), null).toString() === selectedValue.toString();
                                });
                                vm.onSelect(selected);
                                this.clear(true);
                                this.refreshOptions(false); // false = do not trigger dropdown
                                $scope.$apply();
                            }
                        },
                        lodash.get(vm.element, 'options.selectize', {}),
                        vm.additionalOptions
                    );

                $scope.$watch(function() {return vm.element.datasource }, function() {
                    vm.isLoading = true;
                    setTimeout(function() {
                        vm.isLoading = false
                    }, 3000)
                });
            }

            function loadRemoteData(params, postData) {
                if (lodash.has(vm.element, 'datasource.url')) {
                    vm.isLoading = true;
                    var callRemoteApiPromise = callRemoteApi(params, postData);
                    callRemoteApiPromise.then(function(res) {
                        vm.ds = res;
                        vm.isLoading = false;
                    });
                }
            }


            function callRemoteApi(params, postData) {
                if (!params) { params = {}; }
                if (!postData) { postData = {}; }

                var model = new GenericModel(vm.element.datasource.url);
                var method = lodash.get(vm.element.datasource, 'method', 'get');
                return model[method](params, postData).$promise.then(function(res) { //res
                    if (res.success && res.status_code == 200) {
                        return res.data;
                    } else {
                        console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return null;
                    }
                }, function(res) {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(res); // eslint-disable-line no-console
                    return null;
                });
            }
        }
    }
})();